import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const PromoBannerParagraphLoadable = loadable(
  () => import('./PromoBannerParagraph'),
  {
    resolveComponent: components => components.PromoBannerParagraph
  }
);

export const PromoBannerParagraph = WithLazyHydration(
  PromoBannerParagraphLoadable,
  {
    name: 'PromoBannerParagraph'
  }
);
